import React, { useState } from "react";
import { useRef } from "react";
import {  Modal } from "../../Components";
import { Pencil } from "lucide-react";
import BrandprofileImageCropper from "../../Components/Base/BrandprofileImageCropper";

export default function BrandProfileUploader({
  setShowConfirmInfModal,
  form,
  croppedImage,
  setCroppedImage,
  onUploadComplete,
  brandId,
}) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const fileInputRef = useRef(null);
  
  // Create unique ID for this brand's file input
  const fileInputId = `brandFileInput-${brandId || 'default'}`;

  const onSelectFile = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
      if (!validTypes.includes(file.type)) {
        setUploadError("Please select a valid image file (JPEG, PNG, GIF)");
        return;
      }
      
      if (file.size > 5 * 1024 * 1024) {
        setUploadError("Image size should be less than 5MB");
        return;
      }
      
      setUploadError(null);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setSelectedImage(reader.result);
        setShowUploadModal(true);
      };
    }
  };

  const handleUploadComplete = (uploadedUrl) => {
    if (onUploadComplete) {
      onUploadComplete(uploadedUrl);
    }
    setShowUploadModal(false);
    setSelectedImage(null);
  };

  const handleCloseModal = () => {
    setShowUploadModal(false);
    setSelectedImage(null);
    setUploadError(null);
  };

  return (
    <>
      <div className="relative inline-block">
        <div className="relative group">
          {/* Show image or placeholder */}
          <img
            alt="Brand Profile"
            className="w-32 h-32 mt-1 rounded-full object-cover border-4 border-white shadow-lg"
            src={
              croppedImage && croppedImage !== ""
                ? croppedImage
                : form.logo_img_url && form.logo_img_url !== ""
                ? form.logo_img_url
                : form.logo_img && form.logo_img !== ""
                ? form.logo_img
                : `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
            }
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
            }}
          />

          <label
            htmlFor={fileInputId}
            className="absolute bottom-2 right-2 w-8 h-8 bg-green-600 rounded-full flex items-center justify-center text-white cursor-pointer hover:bg-green-700 transition-colors shadow-lg group-hover:scale-110 transform duration-200"
          >
            <Pencil size={16} />
          </label>
        </div>

        <input
          title=" "
          type="file"
          accept="image/jpeg,image/gif,image/png"
          ref={fileInputRef}
          className="hidden"
          onChange={onSelectFile}
          id={fileInputId}
        />
        
        {uploadError && (
          <div className="mt-2 text-sm text-red-600 bg-red-50 px-3 py-2 rounded-lg">
            {uploadError}
          </div>
        )}
      </div>

      {/* Image cropper modal */}
      {selectedImage && showUploadModal && (
        <Modal
          addClass="max-w-2xl rounded-xl shadow-xl bg-white"
          close={handleCloseModal}
        >
          <div className="p-6">
            <BrandprofileImageCropper
              imageUrl={selectedImage}
              setImageSrc={setSelectedImage}
              setCroppedImage={setCroppedImage}
              setSelectedImage={setSelectedImage}
              onUploadComplete={handleUploadComplete}
            />
          </div>
        </Modal>
      )}
    </>
  );
}